import { Icon } from '@talkdesk/cobalt-react-icon'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'
import { SECURITY_KEY_ANIMATION } from '../../../constants/images'
import styles from './WebAuthnLoginAnimation.module.css'

const WebAuthnLoginAnimation = ({ talkdeskIdAssetsURL, isValid = false }) => {
  const theme = useTheme()

  return (
    <div className={`${styles.svgAnimation} ${isValid ? styles.ok : ''}`}>
      <div>
        {/* using an object to force rendering the svg animation, which doesn't reset when re-rendered */}
        <object
          type='image/svg+xml'
          data={SECURITY_KEY_ANIMATION(talkdeskIdAssetsURL)}
          aria-label='webAuthn login'
        />
      </div>
      <div className={styles.svgSuccess}>
        <Icon name='check' size='xlarge' color={theme.green600} />
      </div>
    </div>
  )
}

export default WebAuthnLoginAnimation
